export default {
	'amountForAuthor': "Pagamento all'autore",
	'addNewamountForAuthor': "Aggiungi il pagamento all'autore",
	'paymentIsFixed': 'Il pagamento è fisso',
	'calculateSalary': 'Calcola lo stipendio',
	'managerType': 'Classe',
	'orderOnlyPremium': 'Ordini premium',
	'saveCardStages': "Salva fase",
	'channels': 'Canali',
	'isExpired': 'scaduto',
	'noManager': 'Nessun manager è stato assegnato',
	'selectResponsible': 'Specificare il dirigente responsabile',
	'areaResponsibility': 'Area di responsabilità',
	'responsible': 'Responsabile',
	'generalPriceListForAuthors': 'Impostazioni generali dei prezzi per i siti web',
	'specialPriceForAuthors': 'Prezzo speciale per gli autori',
	'whatsappNameChannel': 'Canale',
	'whatsappFirstReadMess': 'Leggere',
	'whatsappFirstSentMess': 'Inviato',
	'yesterdayDay': 'Ieri',
	'nameWhatsappChannel': 'Canale',
	'messageWhatsappLastText': 'Ultimo messaggio',
	'messageText': 'Messaggio',
	"txtInChatReplyTo": 'In risposta a',
	"replyTo": 'Risposta',
	"thereAreUnfilledFields": "È necessario compilare correttamente tutti i campi prima di salvare!",
	"utmSource": "Fonte principale",
	"utmMedium": "Tipologia pubblicitaria",
	"utmCampaign": "Campagna n.",
	"utmTerm": "Frase chiave",
	"chooseAuthor": "Seleziona l'autore",
	"noManagerWhatsAppChat": "senza direttore",
	"emaiErrorlList": {
		"EMAIL_ERROR_MAILBOX_NOT_FOUND": "Indirizzo del destinatario rifiutato: casella di posta non trovata",
		"EMAIL_ERROR_UNIDENTIFIED_ERROR": "Si è verificato un errore non identificato durante l'invio della posta, contattare il supporto tecnico",
		"EMAIL_ERROR_MESSAGE_EXPIRED": "Messaggio scaduto: impossibile consegnarlo entro 840 minuti",
		"EMAIL_ERROR_STOP_LIST_AMAZON_SES": "L'e-mail non è stata cancellata, così come l'indirizzo nell'elenco di arresto di Amazon SES",
		"EMAIL_ERROR_MAILBOX_FULL": "La lettera non è stata consegnata: la casella di posta del destinatario è piena",
		"EMAIL_ERROR_INVALID_DOMAIN": "Il messaggio non è stato recapitato: il dominio del destinatario non esiste",
		"EMAIL_ERROR_CLIENT_ABUSE_SPAM": "Il cliente ha bloccato un'e-mail da CRM e si è lamentato dello spam da CRM",
	},
	'emailSpamList': 'e-mail di spam',
	'presentationPdfNameHref': 'Titolo testuale del collegamento alla presentazione',
	'italian': "Italiano",
	'french': "Français",
	// Новые с 27.10.23
	'infoAboutAuthor': "Informazioni sull'autore",
	'emailAliasAuthor': "Pseudonimo email dell'autore",
	'emailAuthor': "E-mail dell'autore",
	'fioAuthor': "Nome dell'autore",
	'fioAliasAuthor': "Pseudonimo dell'autore",
	'activeOrderAuthor': "Ordini attivi dell'autore",
	'urlProfileAuthor': "Profilo dell'autore",
	'whatsappListChats': "WhatsApp",
	'whatsappDashboard': 'Whatsapp',
	'nameListChatWhatsapp': "Elenco chat di Whatsapp",
	'whatsappChat': "Chatta su Whatsapp",
	'whatsappChatMissingCall': "Chiamata persa",

	'editWithoutNotice': "Modifica senza notifiche",
	'editOffWithoutNotice': "Disattiva la modalità di modifica",
	'titleSystemMessage': "messaggio di sistema",
	'partner': "Compagno",
	'lastMassages': "Corrispondenza",
	'last50MessagesManager': "Ultimi 50 messaggi che hai inviato",
	'noLast50MessagesManager': "Nessun messaggio ancora",
	'emailFrontSite': "Mail indicata sul sito",
	'isPartnerWebsite': "Sito web del partner",
	'partners': "Partner",
	'countWebsites': "Numero di siti Web",
	'siteChatResponseTemplates': "Modelli di chat",
	'siteChatResponseTemplatesName': "Nome",
	'siteChatResponseTemplatesTemplate': "Testo di risposta",
	'chatTemplates': "Modelli di chat",
	'name_ru': "Nome (rus)",
	'name_de': "Nome (tedesco)",
	'emailPartner': "Accesso partner",
	'countWebsitePartner': "Numero di siti Web",
	'passPartner1': "Nuova password per il partner",
	'passPartner2': "Ripeti la nuova password",
	"partnerCreateAccount": "Ora di creazione dell'account partner",
	'partnerFirstName': "Nome del partner",
	'partnerLastName': "Cognome del partner",
	'partnerWasCreatedSuccessfully': "L'account del partner è stato creato con successo",
	'stageNumberInOrder': "Consegna",
	'fileNumbering': "numero del file",
	'paymentStage': "Pagamento",
	'checkYesPaymentStage': "Ricevuto",
	'checkNoPaymentStage': "Non ricevuto",
	'files': "File",
	'filesAreNotUploaded': "Nessun file è stato caricato",
	'AuthorTasks': "Attività",
	'currentMilestonesPagesCount': "Primo",
	'closeOrderWithoutNotice': "Chiusura rapida",
	'confirmActionWithoutNotice': "Conferma chiusura",
	'youWantСloseOrderWithoutNotice': "Stai per contrassegnare l'ordine corrente come completato con successo e chiuderlo senza avvisare il cliente",
	'youSuccessСloseOrderWithoutNotice': "Ordine chiuso con successo senza notifica come completato",
	'invoiceFooterTitle': "Piè di pagina della fattura (PDF)",
	'noTask': "Nessuna attività ancora",
	'MyAuthorsTasks': "Scadenze",
	'taskAboutOrder': "Attività",
	'noOrderTask': "Non ci sono attività attuali per l'ordine",
	'logAboutOrder': "Cronologia",
	'noOrderComment': "Nessuna cronologia degli ordini",
	'typeEvent': "Evento",
	'systemTypeEvent': "Evento di sistema",
	'needAuthorPutPage': "L'autore deve inviare lo stage in tempo. Pages",
	'logInMenu': "Registri",
  	"orderLog": {
		"NewEmailChangeClientNotAnswerToStatusProcessing": "status \"Nessuna risposta\" -> \"Processing\", email ricevuta dal client",
		"createNewOrderFromEmail": "Ordine creato in base all'e-mail",
		"createNewOrderFromSiteForm": "L'ordine è stato creato tramite un modulo sul sito",
		"createNewOrderFromCRM": "Ordine creato in CRM",
		"changeStatusOrder": "Modifica stato dell'ordine",
		"addNewMilestone": "Aggiunta di un nuovo traguardo a un ordine",
		"deleteMilestone": "Eliminazione di una fase da un ordine",
		"orderStandartCompletedWithPayout": "Completamento standard con successo di un ordine completato con pagamenti all'autore",
		"deleteAuthorFromOrder": "Eliminazione di un autore da un ordine",
		"appointManagerInOrder": "Assegnazione di un nuovo manager all'ordine",
		"managerAcceptedOrder": "Il responsabile delle vendite ha confermato la ricezione dell'ordine",
		"managerSecondAcceptedOrder": "Il responsabile dell'assistenza ha confermato la ricezione dell'ordine",
		"setMarkAsReadChactClient": "Chat con il cliente contrassegnata come letta",
		"updatingOrderData": "Aggiornamento dei dati dell'ordine",
		"updatingStageData": "Aggiornamento dei dati della fase",
		"confirmPaymentMilestone": "La ricezione del denaro è stata confermata sul conto per il pagamento della tappa",
		"changeOrderStatusToInProgressAndAddAuthor": "-> \"In Progress\", nuovo autore assegnato",
		"setFailedOrder": "Ordine contrassegnato come non riuscito e chiuso",
		"setConfirmedOrder": "L'ordine è contrassegnato come completato e chiuso con successo",
		"setNewPriceJmOrderMilestone": "Un nuovo prezzo è stato assegnato per gli autori Junior e Middle per lo stage. Nuova tariffa: ",
		"setNewPriceSOrderMilestone": "Un nuovo prezzo è stato assegnato per gli autori senior per lo stage. Nuova tariffa: ",
		"moveOrderToTrash": "L'ordine è stato spostato nel carrello e chiuso",
		"moveEmailToSpamList": "L'EMAIL del cliente è inclusa nell'elenco spam del CRM. Le email dal client verranno ignorate.",
		"addWorkTypeToOrder": "Un nuovo tipo di lavoro è stato aggiunto all'ordine. Pagine: ",
		"changeOrderStatusToClientNotAnswer": "-> \"Nessuna risposta\"",
		"setCloseOrderWithoutNotice": "L'ordine è contrassegnato come completato con successo e chiuso senza notifica al cliente",
		"sendOrderForApproval": "L'ordine è stato inviato al cliente per l'approvazione",
		"changeOrderStatusToWaitingPayment": "-> \"In attesa di pagamento\"",
		"changeOrderStatusToProcessing": "-> \"In elaborazione\"",
		"changeOrderStatusToWaitingAuthor": "-> \"Alla ricerca di un artista\"",
		"changeOrderStatusToInProgress": "-> \"In corso\"",
		"changeOrderStatusToWaitingApprove": "-> \"Confermato\"",
		"changeOrderStatusToPatchMode": "-> \"Per modificare la modalità\"",
		"autoDistributionOfManagersSuccess": "Assegnazione automatica di un nuovo manager a un ordine",
		"autoDistributionOfManagersError": "Impossibile assegnare automaticamente un nuovo manager",
		'autoDistributionOfManagersToWhatsappSuccess': 'Assegna automaticamente un nuovo manager alla chat di WhatsApp',
		'autoDistributionOfManagersToWhatsAppError': 'Impossibile assegnare automaticamente un nuovo manager alla chat di WhatsApp',
		"noManagerInDutySchedule": "Non ci sono manager nel turno attuale",
		"dubleOrderIn10Minutes": "Ordine doppio negli ultimi 10 minuti",
		"noIfInDayDutySchedule": "Non ci sono condizioni per selezionare un manager",
		"noFreeOtherManagerInDayDutySchedule": "Non c'è nessun manager in servizio che non abbia ancora lavorato con questo cliente",
		"switchOnlineManager": "Il manager è di nuovo online",
		"switchOfflineManager": "Il manager è andato offline",
		"switchAllowedFollowUpOrder": "I messaggi di follow-up sono abilitati per l'ordine del cliente",
		"switchNotAllowedFollowUpOrder": "Disabilita i messaggi di follow-up per un ordine cliente",
		"autoCompletionOrderAfter5Days": "Completamento automatico dell'ordine dopo 5 giorni di silenzio del cliente",
		'changeNewGeneralManager': "È stato nominato un nuovo direttore generale: ",
		'changeOrderStatusToClientNotAnswer': "-> \"Nessuna risposta\" ",
		'managerEmailchangeOrderStatusToClientNotAnswer': "dopo l'email del manager",
		'managerAcceptOrderchangeOrderStatusToClientNotAnswer': "dopo che il manager ha accettato l'ordine",
		'managerCreateOrderchangeOrderStatusToClientNotAnswer': "dopo che il manager ha creato un ordine",
		'authorLeaveOrder': "L'autore ha abbandonato l'ordine",
		'authorAcceptOrder': "L'ordine è stato accettato dall'autore",
	},
	'dateTimeEvent': "Ora dell'evento",
	'numberOrder': "Numero dell'ordine",
	"noNextManager": "---",
	"managerDutySchedule": "Programma dei turni",
	"managerDutyScheduleH1": "Programma dei turni dei manager",
	"managerDutyScheduleNameFirstLine": "1a riga",
	"managerDutyScheduleNameSecondLine": "2a riga",
	"goBack": "Torna indietro",
	"selectMultiManagersTitle": "Seleziona manager...",
	"doYouWantToDeleteManagerFromDay": "Stai per eliminare un manager dal programma di questo giorno",
	"tariffSchedule": "Programma tariffario",
	"iAmOnline": "Sono online",
	"iAmOffline": "Non in linea",
	"changeStatusManagerTitle": "Cambia stato",
	"doYouWantStatusOfflineManager": "Stai andando offline e stai mettendo in pausa l'accettazione degli ordini",
	"doYouWantStatusOnlineManager": "Sei di nuovo online e pronto per accettare ordini",
	"switchOfflineManagerNotification": "Sei andato offline",
	"switchOnlineManagerNotification": "Sei di nuovo online",
	"onlineStatusManager": "Stato",
	"online": "in linea",
	"offline": "Offline",
	"statusFollowUp": "Stato degli invii di follow-up",
	"allowedFollowUp": "Follow-up consentiti",
	"notAllowedFollowUp": "I follow-up sono disabilitati",
	"doYouWantStatusAllowedFollowUpOrder": "Consenti l'invio di messaggi di follow-up al cliente",
	"doYouWantStatusNotAllowedFollowUpOrder": "Disabiliti l'invio di messaggi di follow-up al client",
	"switchNotAllowedFollowUpOrderNotification": "Hai disabilitato il messaggio di follow-up per il cliente",
	"switchAllowedFollowUpOrderNotification": "Hai consentito l'invio di messaggi di follow-up al cliente",
	"authorCostPerPageH1": "Costo di una pagina per l'autore, in euro",
	"allowAuthorPaymentReward": "Confermi il completamento della fase e il pagamento delle royalties all'autore?",
	'balance': "Saldo",
	'topManager': "Principale",
	'changeGeneralManagerTitle': "Cambia direttore generale",
	'doYouWantChangeGeneralManager': "Assegna un nuovo direttore generale",
	'rating': "Voto",
	'newbie': "Novizio",
	'paymentsHistoryOrders': "Ratei",
	'titleDialogChangeOrderStatus': "Seleziona il nuovo stato dell'ordine...",
	'emailAliasManager': "Alias ​​email",
	'sendFromAuthor': "dall'autore",
	'uploadCompletedStage': "Carica una fase completata.",
	'modify': "Modifica",
	'forRevision': "Per la revisione",
	'returnToAuthorForRevision': "Restituisci all'autore per la revisione...",
	'addCommentForAuthor': "Di' all'autore cosa deve essere cambiato:",
	'changeStatusOrderToPatchModeStage': "Hai inviato con successo la fase per la revisione all'autore",
	'waitForConfirmationJobAcceptance': "Attende la conferma dell'accettazione del lavoro.",
	'stagePatchModeNumber': "Patch",
	'editingModeEnabled': "La modalità di modifica è abilitata",
	'acceptJob': "Accetta lavoro",
  	// Новые с 27.10.23

	'addTicket': "Aggiungi ordine",
	'addTask': "Aggiungi attività",
	'addOrderComment': "Aggiungi un commento",
	'noOrderComment': "Non ci sono commenti sull'ordine",
	'unknowUserRole': "Autore sconosciuto",
	'unknowUserName': "Sconosciuto",
	'addOrderCommentSuccess': "Il commento è stato aggiunto con successo all'ordine!",
  	'from': "Da",
	'to': "Prima",
	'reset': "Ripristina",
	'searchByNameAndClient': "Invia un'e-mail al cliente o alla chiamata",
	'save': "Salva",
	'cancel': "Annulla",
	'chooseDate': "Scegli la data",
	'description': "Descrizione",
	'taskView': "Descrizione dell'attività",
	'date': "data",
	'ticket': "Ordine",
	'setByAdmin': "Importante!",
	'delete': "Eliminare",
	'done': "Fatto",
	'notDone': "Non fatto",
	'completedSuccessfully': "Completato con successo",
	'addedSuccessfully': "Aggiunto con successo",
	'setPriceSuccessfully': "Prezzo modificato con successo",
	'changedSuccessfully': "Modificato con successo",
	'deletedSuccessfully': "Eliminato con successo",
  	'name': "Nome",
	'subject': "Articolo",
	'type': "Tipo",
	'pagesCount': "Pagine",
	'milestonesCount': "Fasi",
	'priceEuro': "Prezzo, €",
	'dueDate': "Scadenza",
	'dueTimeAuthor': "Scadenza per l'autore",
	'manager': "Manager",
	'comment': "Un commento",
	'client': "Cliente",
	'level': "Livello",
	'author': "Autore",
	'task': "Compiti",
	'new': "Nuovo",
	'transmitted': "Trasmesso",
	'forRemoval': "Per la cancellazione",
	'clientNotAnswer': "Nessuna risposta",
	'processing': "In corso",
	'waitingPayment': "In attesa del pagamento",
	'waitingAuthor': "Alla ricerca di un artista",
	'inProgress': "In corso",
	'patchMode': "Modifiche",
	'waitingApprove': "Confermato",
	'completed': "Fatto",
	'failedWithPayout': "Non riuscito (tariffa pagata)",
	'failed': "Fallito",
	'createOrder': "Crea un ordine",
	'newtonsLaw': "Legge di Newton",
	'clientsPhone': "Telefono del cliente",
	'clientsEmail': "E-mail del cliente",
	'clientsEmailSecondary': "E-mail del cliente (aggiuntiva)",

	'site': "Sito web",
	'email_host': "Indirizzo del server della posta in arrivo",
	'emailIncomingUserName': "Accesso al server della posta in arrivo",
	'passIncomingEmail': "Password del server di posta in arrivo",
	'emailPort': "Porta del server di posta in arrivo",
	'emailSecure': "Protocollo del server di posta in entrata",
	'emailOutgoingHost': "Indirizzo del server di posta in uscita",
	'emailOutgoingUserName': "Accesso al server di posta in uscita",
	'emailOutgoingUserPassword': "Password del server di posta in uscita",
	'emailOutgoingPort': "Porta del server di posta in uscita",
	'emailOutgoingSecure': "Protocollo del server di posta in uscita",
	'subjectArea': "Oggetto",
	'workType': "Tipo di lavoro",
	'qualityLevel': "Livello di qualità",
	'pagesAmount': "Numero di pagine",
	'workLanguage': "Lingua corrente",
  	'language': "Lingua",
	'loadFile': "Carica file",
	'create': "Creare",
	'orderWasCreatedSuccessfully': "Ordine creato con successo",
	'order': "Ordine",
	'currentOrderStatus': "Stato attuale dell'ordine",
	'price': "Prezzo",
	'refuseWork': "Rifiuta ordine",
	'writeMessage': "Scrivi un messaggio",
	'chatWithAurhor': "Chatta con l'autore",
	'chatWithManager': "Chatta con il manager",
	'invitesWasSent': "Gli inviti sono stati inviati",
	'youMarkedOrderAs': "Hai contrassegnato l'ordine come",
	'confirmAction': "Conferma l'azione",
	'checkFullPaymentStage': "Il cliente ha ricevuto l'intero importo?",
  	'agree': "Inizia l'ordine",
	'youWantToMarkOrderAs': "Stai per contrassegnare l'ordine come",
	'totalWorks': "Ordini totali",
	'currentWorks': "Ordini correnti",
  	'favorites': "Preferiti",
	'invite': "Invitare",
	'performersRequests': "Le candidature degli artisti",
	'select': "Scegliere",
	'yourRequestsWasSentSentSuccessfully': "I tuoi inviti sono stati inviati con successo",
	'youHaveAssignedAuthorToThisProject': "Hai assegnato un autore a questo ordine",
	'thanksWeReceivedYourRequest': "Grazie, abbiamo ricevuto la tua richiesta",
	'managerWillConfirmItSoon': "Il manager lo confermerà presto",
	'pleaseWait': "Per favore aspetta",
	'paymentDetails': "Dettagli sul pagamento",
  	'stage': "Palcoscenico",
	'priceForClient': "Prezzo per il cliente",
	'priceForJuniorAndMiddle': "Prezzo per Junior e Middle",
	'newPriceForJuniorAndMiddle': "Nuovo prezzo per Junior e Middle",
	'priceForSenior': "Prezzo per Senior",
	'newPriceForSenior': "Nuovo prezzo per Senior",
	'pagesAmountShort': "Numero di pagine",
	'loadPhoto': "Carica foto",
	'downloadChecks': "Scarica assegni",
	'confirmPayment': "Conferma pagamento",
	'recommendedPaymentSum': "Importo di pagamento consigliato",
	'totalPaymentSum': "Importo totale del pagamento",
	'lowerThanRecommendedSum': "L'importo è inferiore a quello consigliato",
	'addStage': "Aggiungi fase",
	'sendForApproval': "Invia per l'approvazione",
  	'edit': "Modificare",
	'approve': "Approvare",
	'firstlyAddWorkTypeToOrder': "Seleziona un tipo di lavoro",
	'youdownloadChecksSuccessfully': "Hai scaricato con successo gli assegni",
	'youConfirmedPaymentSuccessfully': "Hai confermato con successo il pagamento",
	'dataWasSentToClientForApproval': "File inviati al client",
	'dataWasSentForApproval': "Documento inviato per l'approvazione",
	'youMarkedStageAs': "Hai contrassegnato il palco come",
	'stageWasMovedToStatus': "Modifica dello stato dell'ordine:",
	'payRewardToAuthor': "Paga i diritti d'autore all'autore",
  	'authorsReward': "Importo tassa",
	'pay': "Paga",
	'doCancel': "Annulla",
	'indicateFailureReason': "Specificare il motivo del fallimento",
	'informationAboutOrder': "Informazione",
	'editInformationAboutOrder': "Modificare",
	'commentAboutOrder': "Commenti",
	'workName': "Soggetto",
	'clientsComment': "Commento del cliente",
	'recommendedSumShort': "Consiglia somma",
	'add': "Aggiungere",
	'attachedFiles': "File allegati | File allegati | File allegati | File allegati",
	'paymentMethod': "Metodo di pagamento",
	'filesFromAuthor': "File dell'autore",
  	'send': "Inviare",
	'sendAutomatical': "Invia automaticamente",
	'filesWasSentToClient': "I file sono stati inviati al client",
  	'refuse': "Rifiutare",
	'youWantToCompleteOrder': "Stai per completare l'ordine",
	'thisActionIsIrreversible': "Questa azione è irreversibile",
	'completeOrder': "Completa l'ordine",
	'orderIsCompletedSuccessfully': "Ordine completato con successo",
	'writeToManager': "Scrivi al manager",
  	'discuss': "Discusso",
	'creationDate': "data di creazione",
	'calculatedSum': "Prezzo stimato",
	'includingVAT': "IVA inclusa",
	'assign': "Assegnare",
	'chooseManager': "Scegli un manager",
	'passwordRecovery': "Recupero password",
	'enterYourEmailAndWeWillSendYouNewPassword': "Inserisci la tua email e ti invieremo una nuova password",
	'recoverPassword': "Recupera password",
	'toLoginPage': "Alla pagina di accesso",
	'newPasswordIsGeneratedAndSentToMail': "La nuova password è stata inviata via email",
  	'registration': "Registrazione",
	'fillFormBelowToCreateNewAccount': "Compila il modulo sottostante per creare un nuovo account",
	'youAreAlreadyLoggedIn': "Sei già loggato!",
  	'entrance': "Entrata",
	'welcomeBack': "Bentornato",
	'pleaseLoginToYourAccount': "Effettua il login al tuo account",
	'password': "Parola d'ordine",
	'repeatPassword': "Ripeti la password",
	'newPassword': "nuova password",
	'yes': "SÌ",
	'no': "NO",
	'confirmDeletion': "Conferma l'eliminazione",
	'doYouWantToDelete': "Stai per eliminare",
	'registrationLinkCreation': "Creazione di un collegamento di registrazione",
	'linkToRegistrationForm': "Link al modulo di registrazione",
	
  	'generate': "creare",
	'close': "Vicino",
	'nickname': "Soprannome",
	'emailForPayment': "IBAN SEPA / Email Transferwise",
	'phone': "Telefono",
	'sex': "Pavimento",
	'country': "Un paese",
	'birthDate': "Data di nascita",
	'surname': "Cognome",
	'profile': "Profilo",
	'subjects': "Elementi",
	'aboutYourself': "Su di me",
	'dataIsSaved': "Dati salvati",
	'totalOrdersCount': "Numero totale di ordini",
	'success': "Successo",
	'personName': "Nome",
	'otherCustomerProfiles': "Altri profili",
	'changeWorkType': "Cambia tipo di lavoro",
	'shortRussian': "Russo",
	'shortGerman': "lui",
	'totalTicketsAmount': "Numero totale di ordini",
	'activatedTickets': "Ordini attivi",
	'income': "Reddito",
	'totalIncome': "Reddito totale",
	'clientEditing': "Modifica di un cliente",
	'additionalEmail': "E-mail aggiuntiva",
	'activatedOrder': "Ordini attivi",
	'changingManagerRequest': "Richiesta di cambio gestore",
	'newManager': "Nuovo direttore",
	'confirm': "Confermare",
	'decline': "Rifiutare",
	'firstlySelectManager': "È necessario innanzitutto specificare un manager",
	'changingManagerRequestIsSent': "È stata inviata una richiesta per cambiare il gestore",
	'requestWasDeclined': "La richiesta è stata annullata",
	'searchByName': "Ricerca per nome",
	'actions': "Azioni",
	'totalOrders': "Ordini totali",
	'paidOrder': "Pagato",
	'hangingOrders': "Sospeso",
	'sitesPreferences': "Impostazioni per i siti",
	'managerEditing': "Modifica di un manager",
	'managerCreating': "Creazione di un manager",
	'sitesSettings': "Impostazioni sito",
	'basicPrices': "Prezzi base",
	'workTypesVisibility': "Visibilità del tipo di lavoro",
	'invoicesData': "Dati per le fatture",
	'siteAutoEmailAnswer': "Risposte automatiche",
	'siteAutoEmailName': "Evento",
	'siteAutoEmailDialogTitile': "Cambia la risposta automatica del sito",
	'siteChatResponseDialogTitile': "Cambia modello di chat del sito",
	'siteAutoEmailTemplate': "Testo dell'e-mail",
	'siteAutoEmailLetterSubject': "Oggetto dell'email (fino a 255 caratteri)",
	'siteAutoEmailTemplateSuccess': "Il testo della risposta per il sito è stato aggiornato!",
	'siteAutoEmailParameter': "Possibili parametri per la sostituzione",
	'changesIsSavedSuccessfully': "Modifiche salvate con successo",
	'siteWasCreatedSuccessfully': "Il sito è stato creato con successo",
	'managersFee': "Commissione responsabile vendite, % dell'ordine",
	'managersFeeSecond': "Commissione responsabile supporto, % dell'ordine",
	'managersGeneralFee': "Compenso del direttore generale, % dell'ordine",
	'deleteLogo': "Elimina logo",
	'firmInfo': "Informazioni sull'azienda",
	'termsAndConditions': "Termini e condizioni",
  	'part': "Parte",
	'addPresentationPdf': "Aggiunta di una presentazione per il sito",
	'deletePresentationPdf': "Elimina presentazione",
	'changePresentationPdf': "Cambia presentazione",
	'changeLogo': "Cambia logo",
	'mainColor': "Colore principale",
	'additionalColor': "Colore aggiuntivo",
	'highlightingText': 'Colore del testo del titolo del sito Web in CRM',
	'highlightingBackground': 'Colore di sfondo del testo del titolo del sito in CRM',
	'showForJunior': "Spettacolo per ragazzi",
	'showForMiddle': "Mostra per Medio",
	'showForSenior': "Spettacolo per Senior",
  	'general': "Generale",
	'bySites': "Per siti",
	'openDiscuss': "Discussione aperta",
  	'opened': "Aprire",
	'number': "Numero",
	'discussTheme': "Oggetto del ricorso",
	'status': "Stato",
	'lastAnswer': "Ultima risposta",
	'answerReceived': "Risposta ricevuta",
	'waitingToAnswer': "In attesa di una risposta",
  	'closed': "Chiuso",
	'isClosed': "Chiuso",
	'openNewDiscuss': "Apri una nuova richiesta",
	'discussText': "Testo del ricorso",
	'doYouWantToCloseDiscuss': "Stai per chiudere il problema",
	'closeDiscuss': "Chiudi discussione",
	'aDiscuss': "Ricorso",
	'discussStatus': "Stato della discussione",
  	'write': "Scrivere",
	'techSupport': "Supporto tecnico",
	'Considerazione in sospeso': "In sospeso",
	'paidOut': "Pagato",
  	'rejected': "Отклонено",
	'payRequest': "Prelievo",
	'writeHowMuchYouWantToWithdraw': "Indica quanto vuoi prelevare",
	'rejectPayment': "Rifiuta il pagamento",
	'paymentRejectingReason': "Motivo del rifiuto del pagamento",
	'currentBalance': "Saldo corrente",
  	'withdraw': "Ritirare",
	'rejectSuccessfully': "Rifiutato con successo",
	'idTransaction': "ID della transazione",
	'sum': "Somma",
	'paymentSystem': "Sistema di pagamento",
	'paymentRequests': "Richieste di pagamento",
	'paymentsHistory': "Storico dei pagamenti",
	'user': "Utente",
	'rejectedPayments': "Pagamenti rifiutati",
	'addWorkType': "Aggiungi tipo di lavoro",
	'responseText': "Rispondi al testo",
	'addAnswer': "Aggiungi una risposta",
	'ago': "Indietro",
	'month(1)': "mese",
	'month(2-5)': "mesi",
	'month(6-0': "mesi",
	'more': "Di più",
	'lessThanMonth': "Meno di un mese",
	'markAllAsRead': "Segna tutti come letti",
	'orders': "Ordini",
	'techSupportShort': "ex. supporto",
	'exchangePageName': "Scambio",
	'tickets': "Ordini",
	'statistics': "Statistiche",
	'finances': "Finanza",
	'tasks': "Compiti",
	'clients': "Clienti",
	'managers': "Manager",
	'authors': "Autori",
	'sites': "Siti web",
	'workTypes': "Tipi di lavoro",
	'templateAnswers': "Risposte modello",
	'scheduledTasks': "Compiti",
	'all': "Tutto",
	'notDone(many)': "Attuale",
	'notRelevant': "Non rilevante",
	'changeStatusTaskTitle': "Modifica dello stato dell'attività",
	'doYouWantStatusTaskNotRelevant': "Contrassegnare l'attività come non pertinente?",
	'switchStatusTaskNotRelevantNotification': "Hai contrassegnato l'attività come non pertinente",
	'doYouWantDeleteTask': "Eliminare l'attività?",
	'deleteTaskNotification': "Hai eliminato l'attività",
	'doYouWantCompletedTask': "Completare l'attività?",
	'completedTaskNotification': "Hai contrassegnato l'attività come completata",
	'sort': "Ordinamento",
	'tasksCalendar': "Calendario delle attività",
	'languages': "Le lingue",
	'accessDenied': "L'accesso è negato",
	'addPhoto': "Aggiungere una foto",
	'male': "Uomo",
	'female': "Donna",
	'searchByOrderName': "Ricerca per nome",
	'addOrder': "Aggiungi un ordine",
	'doYouWantToRejectOrder': "Stai per rifiutare l'ordine",
	'yourPersonalManager': "Il tuo manager personale",
	'requestAnotherManager': "Richiedi un altro manager",
	'writeReason': "Descrivi il motivo",
	'profileEditing': "Modifica del profilo",
	'changePhoto': "Cambia foto",
	'deletePhoto': "Elimina foto",
	'chatWithYourManager(p1)': "Chat con il tuo",
	'chatWithYourManager(p2)': "Manager",
	'chatByOrder': "Chat per ordine",
	'chatAuthorByOrder': "Chat con l'autore per ordine",
	'chatWithManagerByOrder': "Chat con il gestore degli ordini",
  	'search': "Ricerca",
	'copywriter': "Autore",
	'admin': "Amministratore",
	'successNotification': "Con successo",
	'dangerNotification': "Attenzione",
	'errorNotification': "Errore",
	'fieldFilledIncorrect': "Il campo è compilato in modo errato",
	"trash": "Cestino",
	"titleDialogMoveTrash": "Sposta l'ordine in...",

	// --------------- Чат
	'chatTrackingOpensTimes': "Orari di apertura",
	'chatTrackingLastOpened': "Ultima apertura",

	// --------------- Заказ
	'orderFailedFeeNotPaid': "Ordine non riuscito - cliente rifiutato (commissione non pagata)",
	'orderFailedFeePartiallyFullyPaid': "Ordine non riuscito - cliente rifiutato (commissione parzialmente/interamente pagata)",
	'clientNotContacting': "Ordine fallito - il cliente non risponde",
  	'spam': "Spam",
	'duplicate': "Duplicare",

	// --------------- V2
	'newMessagesCountDisplay': "Nuovo",
	'logout': "Esci",
	'russian': "Русский",
	'german': "Deutsch",
	"sunday": "Domenica",
	"monday": "Lunedi",
	"tuesday": "Martedì",
	"wednesday": "Mercoledì",
	"thursday": "Giovedì",
	"friday": "Venerdì",
	"saturday": "Sabato",
	"sundayShort": "Domenica",
	"mondayShort": "Lunedi",
	"tuesdayShort": "Martedì",
	"wednesdayShort": "Mercoledì",
	"thursdayShort": "Giovedì",
	"fridayShort": "Venerdì",
	"saturdayShort": "Sabato",
	"january": "Gennaio",
	"february": "Febbraio",
	"march": "Marzo",
	"april": "Aprile",
	"may": "Maggio",
	"june": "Giugno",
	"july": "Luglio",
	"august": "Agosto",
	"september": "Settembre",
	"october": "Ottobre",
	"november": "Novembre",
	"december": "Dicembre",
	"gennaioGenitivo": "Gennaio",
	"februaryGenitivo": "Febbraio",
	"marchGenitive": "Martha",
	"aprilGenitive": "aprile",
	"mayGenitive": "Maggio",
	"juneGenitive": "Giugno",
	"julyGenitive": "Luglio",
	"augustGenitive": "Agosto",
	"septemberGenitive": "Settembre",
	"octoberGenitive": "Ottobre",
	"novemberGenitive": "Novembre",
	"decemberGenitive": "Dicembre",
  	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "La legge di Newton",
	"topic": "Soggetto",
	"finished": "Completato",
	"stages": "Fasi",
	"confirmUploading": "Conferma caricamento",
	"fileDeletedSuccessfully": "Il file è stato eliminato con successo",
	"fileDeletionError": "Si è verificato un errore durante il tentativo di eliminare un file",
	"isConfirmingStage": "La fase è attualmente in fase di conferma da parte del manager",
	"changeTemplateAnswer": "Cambia modello di risposta",
  	"pages": "{n} pagine | {n} pagina | {n} pagine | {n} pagine",
	"doYouWantToDeleteAuthorFromOrder": "Stai per eliminare l'autore dall'ordine",
	"doYouWantToDeleteFile": "Stai per eliminare un file",
	"youDeletedAuthorFromOrder": "Hai rimosso l'autore da questo ordine",
	"noDataAvailable": "Nessun dato trovato",
	"secondsAgo": "0 secondi fa | {n} secondi fa | {n} secondi fa | {n} secondi fa",
	"minutesAgo": "0 Minuti fa | {n} Minuti fa | {n} Minuti fa | {n} Minuti fa",
	"hoursAgo": "0 ore fa | {n} ore fa | {n} ore fa | {n} ore fa",
	"daysAgo": "0 giorni fa | {n} giorni fa | {n} giorni fa | {n} giorni fa",
	"yearsAgo": "0 Anni fa | {n} Anni fa | {n} Anni fa | {n} Anni fa",
	"justNow": "Adesso",
  	// --------------- end V3

	"placeholderGlovalSearchOrderById": "Ordine di ricerca per numero",
	"resultGlovalSearchOrderById": "Risultato della ricerca dell'ordine per numero",
	"textNoResultGlovalSearchOrderById": "N. ordine non trovato nel sistema",

	"txtBtnManagerGetOrder": "Accetta ordine",
	"titleModalAddNewManager": "Stai confermando un manager?",
	"titleModalManagerGetOrder": "Accetta ordine",
	"promtModalAddNewManager": "Vuoi assegnare un nuovo manager?",
	"promtModalManagerGetOrder": "Accetti l'ordine",

	"txtBtnChatMarkAsRead": "Segna come letto",
	"notifySuccessChatMarkAsRead": "Questa chat è stata contrassegnata come letta!",

	"listTickets": {
		"idOrder": "No",
		"timeOrder": "Data",
		"nameOrder": "Nome dell'ordine",
		"websiteOrder": "Sito",
	},

	"exchange": {
		'id': '№',
		'name': "Soggetto",
		'area': "Articolo",
		'type': "Tipo",
		'page': "Pagine",
		'stage': "Fasi",
		'price': "Prezzo",
		'price_junior_middle': "Prezzo per Junior/Medio",
		'price_senior': "Prezzo per Anziani",
		'deadline': "Scadenza",
		'accept': "Andare al lavoro",
		'decline': "Rifiutare",
		'confirmAction': "Conferma l'azione",
		'confirmActionText': "Stai per accettare questo ordine.",
		'confirmActionTextFalse': "Stai per rifiutare l'invito a questo ordine.",
		'confirmPopup': "Confermare",
		'order': "Ordine",
		'countStages': "Numero di stadi",
		'nameWork': "Soggetto",
		'subject': "Articolo",
		'typeWork': "Tipo di lavoro",
		'levelQuality': "Livello di qualità",
		'countPages': "Numero di pagine",
		'attachFile': "Files allegati",
		'langWork': "Linguaggio di esecuzione",
		'comment': "Un commento",
		'getToWork': "Iniziare!",
		'filter': "Filtro",
		'searchToName': "Поиск по названию",
		'level': "Livello",
		'off': "Da",
		'to': "Prima",
		'reset': "Ripristina",
		'inviteDecline': "Invito rifiutato",
		'inviteDeclineText': "Hai rifiutato con successo l'invito. Potrai comunque inviare una richiesta per questo ordine se cambi idea.",
		'inviteAccept': "Invito accettato",
		'inviteAcceptText': "Grazie, puoi iniziare.",
		'requestSend': "Richiesta inviata",
		'requestSendText': "Grazie, abbiamo ricevuto la tua richiesta. Il direttore lo confermerà presto. Attendere prego",
  		'success': "Con successo",
		'successText': "Completato con successo",
		'deleteText': "Eliminato con successo",
		'acceptText': "Aggiunto con successo",
	},
	"stats": {
		"junior": "Economy",
		"middle": "Business",
		"senior": "Academic",
		"income": "Reddito",
		"total": "Netto",
		"totalIncome": "Reddito",
		"privateIncome": "Guadagno personale",
		"sitesCount": "Siti",
		"paidOrdersCount": "Pagato",
		"waitingOrdersCount": "Sospeso",
		"graphIncome": "Guadagno personale",
		"graphOrders": "Ordini",
		"graphIncomeGlobal": "Reddito",
		"graphOrdersPaid": "Ordini 'pendenti'.",
		"completeOrder": "Completato",
		"successOrder": "Successo",
		"today": "Oggi",
		"yesterday": "Ieri",
		"currentWeek": "Questa settimana",
		"prevWeek": "La settimana scorsa",
		"current_month": "Corrente mese",
		"last_month": "Lo scorso mese",
		"last_three_month": "3 mesi",
		"last_six_month": "Metà anno",
		"last_year": "Anno",
		"all_time": "Durante tutto questo tempo",
		"active": "Ordini attivi",
		"clientsCount": "Clienti",
		"authorsCount": "Autori",
		"managersCount": "Manager",
		"incomeTotal": "Grossolano",
		"incomeClean": "Netto",
		"ordersCount": "Всего заказов",
		"graphUsers": "Nuovi utenti",
		"graphQualityLevels": "Ordini per livello di qualità",
		"graphSubjects": "Ordini per articolo",
		"graphAdminIncome": "Rapporto profitto",
		"newPaidTickets": "Ordini",
		"completedTickets": "Stati dell'ordine completato",
		"conversion": "Conversione",
		"date": "Data",
		"manager": "Manager",
		"clients": "Clienti",
		"authors": "Autori",
		"mangers": "Manager",
		"graph_new": "Nuovi ordini",
		"paid": "Ordini pagati",
		"completed": "Fatto",
		"failed": "Fallito",
	},
};
